import { Provider, INJECTOR, Injector, Optional } from '@angular/core';
import { AlarmGroupForm, IAlarmGroupForm } from './alarm-group.form';
import { RxapFormBuilder, RXAP_FORM_DEFINITION_BUILDER, RXAP_FORM_DEFINITION, RXAP_FORM_INITIAL_STATE } from 'eurogard-forms';

export const FormProviders: Provider[] = [AlarmGroupForm];
export const FormComponentProviders: Provider[] = [{
    provide: RXAP_FORM_DEFINITION,
    useFactory: FormFactory,
    deps: [ INJECTOR,[ new Optional(), RXAP_FORM_INITIAL_STATE ] ]
  }];
export const FormBuilderProviders: Provider[] = [{
    provide: RXAP_FORM_DEFINITION_BUILDER,
    useFactory: FormBuilderFactory,
    deps: [ INJECTOR ]
  }];

export function FormFactory(injector: Injector, state: IAlarmGroupForm | null): AlarmGroupForm {
  return new RxapFormBuilder<IAlarmGroupForm>(AlarmGroupForm, injector).build(state ?? {});
}

function FormBuilderFactory(injector: Injector): RxapFormBuilder<IAlarmGroupForm> {
  return new RxapFormBuilder<IAlarmGroupForm>(AlarmGroupForm, injector);
}
